import { makeVar } from '@apollo/client';
import _debounce from 'lodash/debounce';
import cartAPI from './cartAPI';

const cartItemsVar = makeVar([]);

export const getCartItems = _debounce(() => {
  cartAPI.get('/user/get').then(response => {
    cartItemsVar(
      response.data?.Items?.map(item => item.Id.split(':')[1]) ?? [],
    );
  });
}, 1000);

document.addEventListener('shoppingCart.remove.success', () => {
  getCartItems();
});

export default cartItemsVar;
